import BaseApplication from './base.js';

const $ = require('jquery');
global.$ = global.jQuery = $;

import stickybits from 'stickybits';

'use strict';

export class PageApplication extends BaseApplication {
	constructor(args = []) {
		super(args);

		this.setLog('[Extension] ', "En");

		// sticky
		var targetHeader = document.getElementById("header");
		if (!this.isEmpty(targetHeader)) {
			var stickyHeader = stickybits(targetHeader, { useStickyClasses: true });
		}
		var stickyMenu = stickybits('#sticky', { stickyBitStickyOffset: 60 });
		if (this.isIE() && !this.isEmpty(targetHeader)) {
			var observer = new MutationObserver(function(mutations) {
			    stickyMenu.update();
			});
			observer.observe(targetHeader, { attributes : true, attributeFilter : ['style'] });
		}

		// accordion
		$(function() {
	        $('.sidemenu .trigger').click(function() {
	            $(this).next('ul').slideToggle();
	            $(this).parent('li').toggleClass('active');

	            $('.sidemenu .trigger').not($(this)).next('ul').slideUp();
	        });
	    });

		// season slider
		this.setSeasonSlider();
	}

	callback() {
		this.showPerfomance();
		return null;
	}

	setSeasonSlider() {
		if (typeof window.Swiper != "undefined") {
			const galleryThumbs = new Swiper('.seasonSlider .gallery-thumbs', {
		      spaceBetween: 10,
		      slidesPerView: 7,
		      freeMode: true,
		      watchSlidesVisibility: true,
		      watchSlidesProgress: true,
		      navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		      },
		    });
		    const galleryTop = new Swiper('.seasonSlider .gallery-top', {
		      spaceBetween: 0,
		      thumbs: {
		        swiper: galleryThumbs
		      }
		    });
		}
    }
};

// if(typeof window.Application == "undefined" || window.Application == null) {
	window.Application = new PageApplication();
// }
